/// <reference path="tsdeclarations/osf.d.ts" />
/// <reference path="tsdeclarations/msajax.d.ts" />
// OSFJS: Need alternative for FILE_VERSION_STRING THREE_PARTS_FILE_VERSION_STRING
let stringResourceFileValue = "osfruntime_strings.js";
if (DEBUG) {
  stringResourceFileValue = "osfruntime_strings.debug.js";
}
namespace OSF {
  export let Constants = {
    FileVersion: "0.0.0.0",
    ThreePartsFileVersion: "0.0.0",
    OmexAnonymousServiceName: "__omexExtensionAnonymousProxy",
    OmexAnonymousServiceExtension: "/anonymousserviceextension.aspx",
    OmexGatedServiceName: "__omexExtensionGatedProxy",
    OmexGatedServiceExtension: "/gatedserviceextension.aspx",
    OmexUnGatedServiceName: "__omexExtensionProxy",
    OmexUnGatedServiceExtension: "/ungatedserviceextension.aspx",
    OmexConsentNotificationPage: "/client/consentnotification.aspx",
    Http: "http",
    Https: "https",
    ProtocolSeparator: "://",
    SignInRedirectUrl: "/logontoliveforwac.aspx?returnurl=",
    ETokenParameterName: "et",
    ActivatedCacheKey: "__OSF_RUNTIME_.Activated.{0}.{1}.{2}",
    ConsentedCacheKey: "__OSF_RUNTIME_.Consented.{0}.{1}.{2}",
    AuthenticatedConnectMaxTries: 3,
    IgnoreSandBoxSupport: "Ignore_SandBox_Support",
    IEUpgradeUrl: "https://office.microsoft.com/redir/HA102789344.aspx",
    OmexForceAnonymousParamName: "SKAV",
    OmexForceAnonymousParamValue: "274AE4CD-E50B-4342-970E-1E7F36C70037",
    EndPointInternalSuffix: "_internal",
    // CacheKey name for storing SharePoint Catalog trusted locations.
    SPCatalogTrustedLocationsCacheKey: "__OSF_RUNTIME_.SPCatalog_TrustedLocations",
    // Cache table for storing addins browser permissions
    AddinPermissionsTable: "OSF.ADDINS.AddinPermissions",
    // OSFJS: Need alternative for pre-processor.
    // #ifdef OSFSCRIPT_DEBUG
    // StringResourceFile: "osfruntime_strings.debug.js"
    // #else
    StringResourceFile: stringResourceFileValue,
    // #endif
  };
}
